import axios from 'axios';

// Usamos axios diretamente aqui, pois não precisamos do interceptor que adiciona o token
const API_URL = 'http://localhost:3001/api';

const getServicosByUserId = async (userId) => {
  const { data } = await axios.get(`${API_URL}/public/services/${userId}`);
  return data;
};

const getDisponibilidade = async (userId, servicoId, data) => {
  const response = await axios.get(`${API_URL}/public/agendamentos/disponibilidade/${userId}`, {
    params: { servicoId, data }
  });
  return response.data;
};

// Precisamos da lógica de backend para isso, vamos apenas preparar
const createAgendamento = async (agendamentoData) => {
  // const { data } = await axios.post(`${API_URL}/public/agendamentos`, agendamentoData);
  // return data;
  console.log("Enviando para o backend:", agendamentoData);
  return { message: 'Agendamento criado com sucesso!' }; // Simulação por enquanto
};

const publicService = {
  getServicosByUserId,
  getDisponibilidade,
  createAgendamento
};

export default publicService;